<template>
  <section v-show="active" class="app-modal__section">
    <div class="app-modal__section-head">
      <h4>{{ text.modal.form.address.title }}</h4>
      <p>{{ text.modal.form.address.subtitle }}</p>
    </div>

    <div class="app-modal__grid two-columns">
      <div v-if="showBillingAddressToggle" class="app-modal-field full-width">
        <label class="app-modal-toggle app-modal-toggle--primary">
          <input
            type="checkbox"
            :checked="usesBillingAddress"
            @change="toggleUseBillingAddress"
          />
          <span>{{ text.modal.form.address.fields.useBillingAddress }}</span>
        </label>
      </div>

      <label v-if="!shouldHideAddressFields" class="app-modal-field full-width">
        <span>{{ text.modal.form.address.fields.address }}</span>
        <input v-model="form.address" type="text" class="form-control" :placeholder="text.modal.form.address.placeholders.address" />
      </label>

      <div v-if="!shouldHideAddressFields" class="app-modal-field">
        <span>{{ text.modal.form.address.fields.country }}</span>
        <multiselect
          v-model="form.country"
          :options="countryOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="128"
          open-direction="below"
          :placeholder="text.modal.form.address.placeholders.country"
          class="app-modal-select"
        >
          <template #noResult>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
          <template #noOptions>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
        </multiselect>
      </div>

      <div v-if="!shouldHideAddressFields" class="app-modal-field">
        <span>{{ text.modal.form.address.fields.state }}</span>
        <multiselect
          v-model="form.state"
          :options="stateOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="128"
          open-direction="below"
          :placeholder="text.modal.form.address.placeholders.state"
          class="app-modal-select"
        >
          <template #noResult>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
          <template #noOptions>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
        </multiselect>
      </div>

      <label v-if="!shouldHideAddressFields" class="app-modal-field">
        <span>{{ text.modal.form.address.fields.city }}</span>
        <input v-model="form.city" type="text" class="form-control" :placeholder="text.modal.form.address.placeholders.city" />
      </label>

      <label v-if="!shouldHideAddressFields" class="app-modal-field">
        <span>{{ text.modal.form.address.fields.zipCode }}</span>
        <input v-model="form.zipCode" type="text" class="form-control" :placeholder="text.modal.form.address.placeholders.zipCode" />
      </label>
    </div>
  </section>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('customers');

export default {
  name: 'CustomerSectionAddress',
  props: {
    active: { type: Boolean, default: false },
    form: { type: Object, required: true },
    showBillingAddressToggle: { type: Boolean, default: false },
    countryOptions: { type: Array, default: () => [] },
    stateOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      text,
    };
  },
  computed: {
    usesBillingAddress() {
      const normalized = String(this.form?.useBillingAddress || '').trim().toLowerCase();
      return normalized === 'si' || normalized === 'sí' || normalized === 'true' || normalized === '1';
    },
    shouldHideAddressFields() {
      return this.showBillingAddressToggle && this.usesBillingAddress;
    },
  },
  methods: {
    toggleUseBillingAddress(event) {
      const checked = Boolean(event?.target?.checked);
      this.form.useBillingAddress = checked ? 'Si' : 'No';
    },
  },
};
</script>
